import { SolutionOutlined } from '@ant-design/icons'
import {
  dashboard,
  proposalsHistory,
  proposalCheck,
  chat,
  lgpdTerms,
  bacenTerms,
  proposalsListTwo,
  proposalsListSearch
} from '../routes'

const proposals = {
  name: 'Propostas',
  icon: SolutionOutlined,
  routes: [
    proposalsListSearch,
    proposalsListTwo
  ]
}

const consultantsRoutes = [
  dashboard,
  proposalsHistory,
  proposalCheck,
  proposals,
  chat,
  lgpdTerms,
  bacenTerms
]

export default consultantsRoutes
